import styled, { css } from 'styled-components';
import { Breakpoint } from '../../styles/constants';

export const FLEX_ROWS = css`
  display: flex;
  flex-direction: row;
`;

export const FLEX_COLS = css`
  display: flex;
  flex-direction: column;
`;

/**
 * Sometimes designs will need to have items in rows, and then
 * as you add more content it needs to become columns.
 */
export const FLEX_ROW_TO_COL = (breakpoint: Breakpoint) => css`
  ${FLEX_ROWS}

  ${breakpoint} {
    ${FLEX_COLS}
  }
`;

/**
 * The inverse of FLEX_ROW_TO_COL
 */
export const FLEX_COL_TO_ROW = (breakpoint: Breakpoint) => css`
  ${FLEX_COLS}

  ${breakpoint} {
    ${FLEX_ROWS}
  }
`;

export const Row = styled.div`
  ${FLEX_ROWS}
  margin-left: -10px;
  margin-right: -10px;
  position: relative;
`;

export const Col = styled.div`
  ${FLEX_COLS}
  flex: 1;
  flex-wrap: wrap;
  margin: 0 10px;
`;
